<template>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 24 30" style="enable-background:new 0 0 24 24;" xml:space="preserve"><path d="M21.528,3.847l-1.376-1.376c-1.137-1.138-2.99-1.138-4.128,0L3.642,14.854c-0.078,0.078-0.135,0.174-0.165,0.28  l-1.834,6.421c-0.065,0.227-0.001,0.47,0.165,0.637c0.124,0.124,0.289,0.19,0.459,0.19c0.06,0,0.12-0.008,0.178-0.025l6.421-1.835  c0.106-0.03,0.203-0.087,0.281-0.165L21.528,7.975c0.552-0.551,0.855-1.284,0.855-2.064C22.383,5.131,22.08,4.398,21.528,3.847z   M8.347,19.322L3.21,20.789l1.468-5.136l9.971-9.971l3.669,3.669L8.347,19.322z M20.611,7.058l-1.376,1.376l-3.669-3.669  l1.376-1.376c0.632-0.632,1.661-0.631,2.294,0l1.376,1.376c0.307,0.306,0.475,0.714,0.475,1.147  C21.086,6.344,20.917,6.751,20.611,7.058z"/></svg>
</template>

<script>
export default {
    name: 'IconEdit',
}
</script>

<style lang="scss" scoped>
</style>